import { useState } from "react";
import { Modal, Field, inputCls } from "./ui";
import { ESTADOS, ORIGENES, PERFILES, INTERESES, uid, day } from "./store";

const EMPTY = {
  nombre: "", email: "", telefono: "", whatsapp: "", origen: "Web", perfil: "Inversor puro",
  interes: "Tibio", estado: "Nuevo", unidades: 1, presupuesto: "Por confirmar",
  proximaAccion: "", fechaProxima: "", notas: "",
};

export const LeadForm = ({ initial, onSave, onClose }) => {
  const [f, setF] = useState(initial ? { ...initial } : EMPTY);
  const [error, setError] = useState("");
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    if (!f.nombre.trim()) {
      setError("El nombre es obligatorio");
      return;
    }
    onSave({
      ...f,
      id: f.id || uid(),
      unidades: Number(f.unidades) || 1,
      creado: f.creado || day(0),
      interacciones: f.interacciones || [],
    });
  };

  const sel = (k, opts) => (
    <select data-testid={`lead-field-${k}`} className={inputCls} value={f[k]} onChange={(e) => set(k, e.target.value)}>
      {opts.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  );

  return (
    <Modal title={initial ? "Editar lead" : "Nuevo lead"} onClose={onClose} wide>
      <form onSubmit={submit} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field label="Nombre *">
          <input data-testid="lead-field-nombre" className={inputCls} value={f.nombre} onChange={(e) => set("nombre", e.target.value)} placeholder="Nombre y apellidos" />
        </Field>
        <Field label="Email">
          <input data-testid="lead-field-email" type="email" className={inputCls} value={f.email} onChange={(e) => set("email", e.target.value)} placeholder="email@ejemplo.com" />
        </Field>
        <Field label="Teléfono">
          <input data-testid="lead-field-telefono" className={inputCls} value={f.telefono} onChange={(e) => set("telefono", e.target.value)} placeholder="+34 ..." />
        </Field>
        <Field label="WhatsApp">
          <input data-testid="lead-field-whatsapp" className={inputCls} value={f.whatsapp} onChange={(e) => set("whatsapp", e.target.value)} placeholder="+34 ..." />
        </Field>
        <Field label="Origen">{sel("origen", ORIGENES)}</Field>
        <Field label="Perfil">{sel("perfil", PERFILES)}</Field>
        <Field label="Nivel de interés">{sel("interes", INTERESES)}</Field>
        <Field label="Estado">{sel("estado", ESTADOS)}</Field>
        <Field label="Unidades de interés">
          <input data-testid="lead-field-unidades" type="number" min="1" className={inputCls} value={f.unidades} onChange={(e) => set("unidades", e.target.value)} />
        </Field>
        <Field label="Presupuesto confirmado">{sel("presupuesto", ["Sí", "No", "Por confirmar"])}</Field>
        <Field label="Próxima acción">
          <input data-testid="lead-field-proxima" className={inputCls} value={f.proximaAccion} onChange={(e) => set("proximaAccion", e.target.value)} placeholder="Enviar contrato..." />
        </Field>
        <Field label="Fecha próxima acción">
          <input data-testid="lead-field-fecha" type="date" className={inputCls} value={f.fechaProxima} onChange={(e) => set("fechaProxima", e.target.value)} />
        </Field>
        <div className="sm:col-span-2">
          <Field label="Notas">
            <textarea data-testid="lead-field-notas" rows={3} className={inputCls} value={f.notas} onChange={(e) => set("notas", e.target.value)} />
          </Field>
        </div>
        {error && <p data-testid="lead-form-error" className="text-sm text-red-600 sm:col-span-2">{error}</p>}
        <div className="flex justify-end gap-3 sm:col-span-2">
          <button type="button" onClick={onClose} className="rounded-lg border border-gray-200 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50">Cancelar</button>
          <button data-testid="lead-form-submit" type="submit" className="rounded-lg bg-[#2d5a3d] px-5 py-2 text-sm font-semibold text-white hover:bg-[#3a7a50]">
            {initial ? "Guardar cambios" : "Crear lead"}
          </button>
        </div>
      </form>
    </Modal>
  );
};
